import { basicPathND } from '../basicPathND';

export const fetchLessonsAllND = async (params) => {
    const path = '/mp/lessons/all';
    const type = 'get';
    return await basicPathND(params, path, type);
}